import { useTranslation } from "react-i18next";
// function translate() {
//     var t = useTranslation();
// }


export const pkjInfo: any[] = 
[

    {
        slug: "https://oncquestlabs.com/blog/benefits-of-regular-health-check-up/",
        heading: "Why do you need a Health Check-Up?",
        listImg: "/assets/img/php1.png",
    },
    {
        slug: "https://oncquestlabs.com/blog/5-reasons-why-regular-health-check-up-is-important/",
        heading: "5 Reasons Why Regular Health Check-up is Important",
        listImg: "/assets/img/php2.png",
    },
    {
        slug: "https://oncquestlabs.com/blog/regular-health-checkup-tests/",
        heading: "When do adults need a checkup?",
        listImg: "/assets/img/php3.png",
    },
    {
        slug: "https://oncquestlabs.com/blog/all-about-health-checkups/",
        heading: "Taking health seriously - All about health packages",
        listImg: "/assets/img/php4.png",
    },
];